export const searchOptions = [{ label: 'WSIN', value: 'wsin' }];

export const defaultFilter = {
	searchOptionType: searchOptions[0].value,
	searchValue: ''
};
